import {StyleSheet} from "aphrodite-jss"

export const styles = StyleSheet.create({
    container : {
        height: "wrap-content",
        minHeight: "150px",
        minWidth: "400px",
        width: "400",
        maxWidth: "600px",
        backgroundColor: "white",
        padding: "10px",
    },
    content: {
        display: "flex",
        flexDirection: "column"
    },
    name:{
        fontSize: "24px",
        fontWeight: "bold",
        marginLeft: "auto",
        marginRight: "auto",
        color: "black",
        "& :active": {
            color: "black"
        }

    },
    description: {
        textAlign: "justify",
        fontSize: "14px"
    },
    participants:{
        marginTop: "10px",
        "& #label": {
            fontWeight: "bold"
        },
        "& #participants": {
            display: "inline",
            "& > div": {
                display: "inline-block",
                fontSize: "14px",
                fontWeight: "normal"
            }
        }
    },

});


// WEBPACK FOOTER //
// ./src/components/dialogs/ProjectDetailDialogStyle.ts